import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Parser from 'html-react-parser';

const FormGroup = ({
    label = '',
    labelClass = '',
    fieldClass = '',
    button = null,
    errors = [],
    className = {},
    children
}) => {
    const [stateErrors, setStateErrors] = useState(errors);

    useEffect(() => {
        setStateErrors(errors);
    }, [errors]);

    const getClassGroup = () => {
        return classNames({
            'form-group': true,
            'has-error': stateErrors.length,
            ...className
        });
    };

    const getErrors = () => {
        return stateErrors.join('<br/>');
    };

    return (
        <div className={getClassGroup()}>
            {label
                ? <label className={`control-label ${labelClass}`}>
                    {Parser(label)}
                  </label>
                : null
            }
            <div className={fieldClass}>
                {children}
                {stateErrors.length
                    ? <span className="error-message help-block">{Parser(getErrors())}</span>
                    : null
                }
            </div>
            {button}
        </div>
    );
};

FormGroup.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    labelClass: PropTypes.string,
    fieldClass: PropTypes.string,
    button: PropTypes.node,
    errors: PropTypes.array,
    className: PropTypes.object,
    children: PropTypes.node
};

export default FormGroup;
